import {
    GET_CASE_CATEGORIES_QUERY,
    GET_CASE_CATEGORY_SETS_QUERY,
    type GetCaseCategoriesData,
    type GetCaseCategoriesVariables,
    type GetCaseCategorySetsData,
    type GetCaseCategorySetsVariables,
} from '~/graphql/queries/caseCategories';
import type { CaseCategoryType, CaseCategorySetType } from '~/generated/types';

export const getCaseCategories = async(): Promise<CaseCategoryType[]> => {
    const { data } = await useAsyncQuery<GetCaseCategoriesVariables, GetCaseCategoriesData>(GET_CASE_CATEGORIES_QUERY);

    return data.value?.caseCategories.edges.map(edge => edge.node) || [];
};

export const getCaseCategorySets = async(): Promise<CaseCategorySetType[]> => {
    const { data } = await useAsyncQuery<GetCaseCategorySetsVariables, GetCaseCategorySetsData>(GET_CASE_CATEGORY_SETS_QUERY);

    return data.value?.caseCategorySets.edges.map(edge => edge.node) || [];
};
